import { AfterContentInit, AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortable } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { LoginModel } from 'src/app/model/login.model';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { SnackBarService } from 'src/app/services/snack-bar-service.service';
import { FrotaService } from '../frota.service';
import { IFiltroFrotaModel, IFrotaModel } from '../model/frota.model';

@Component({
  selector: 'app-pesquisa-frota',
  templateUrl: './pesquisa-frota.component.html',
  styleUrls: ['./pesquisa-frota.component.scss']
})
export class PesquisaFrotaComponent implements OnInit, OnDestroy {

  usuario !: LoginModel | undefined;

  private subs = new Subscription();

  displayedColumns = ['codigo', 'nomeReduzido', 'descricao', 'municipio', 'estado'];

  filtro!: IFiltroFrotaModel;

  public dataSource!: MatTableDataSource<IFrotaModel>;

  @ViewChild('search',{}) parametroElement!: ElementRef<HTMLInputElement>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  loading = 0;

  constructor(private frotaService: FrotaService, 
    private authenticationService: AuthenticationService,
    private snackBar: SnackBarService,
    private dialogRef: MatDialogRef <PesquisaFrotaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.filtro = data.dataKey;      
  }

  ngOnInit(): void {

     // Liga a animação de Loading (Spinner) na tela 
     this.loading++;

     this.usuario = this.frotaService?.usuario;

    // Verifica se o guid do usuário é ou continua válido.
    this.authenticationService.validate(this.frotaService?.usuario?.retorno?.guid ?? '')
      .then((dados => {
        
        if (!dados.sucesso) {

          this.snackBar.flashMessage(this.authenticationService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
          this.usuario = undefined;

        } else {

          if (this.filtro.parametro) {

            this.filtrar();
            
          }
        }
      }))
      .catch(() => {
        this.snackBar.flashMessage(this.authenticationService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
       })
      .finally(() => { 
        this.loading--; 
      });
  }

  // ngAfterViewInit() {
   
  //   setTimeout(()=>{ // this will make the execution after the above boolean has changed
  //     this.parametroElement.nativeElement.focus();
  //   },500);
    
  // }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  onSubmit() {
    this.filtrar();
  }

  limpaFiltro() {
    this.filtro.coluna = "1";
    this.filtro.operador = 1;
    this.filtro.parametro = "";
    this.dataSource = new MatTableDataSource<IFrotaModel>();
  }

  fechar(){
    this.dialogRef.close();
  }

  getRecord(row: IFrotaModel) {
    this.dialogRef.close({data: row});
  }

  ngOnDestroy() {
    if (this.subs) {
      this.subs.unsubscribe();
    }
  }

  private filtrar() {
    
    this.loading++;

    this.subs.add(this.frotaService.listFrota(this.filtro)
      .subscribe({
        next: (res) => {
          if (res?.sucesso) {
            this.dataSource = new MatTableDataSource<IFrotaModel>(res.retorno);
            this.dataSource.paginator = this.paginator;
            this.sort.sort(({ id: 'codigo', start: 'asc' }) as MatSortable);
            this.sort.disableClear = true;
            this.dataSource.sort = this.sort;
          } 
        },
        complete: () => {
          this.loading--;
        }
      }));
  }

}
